import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.js';

export function ProtectedRoute({ children }: { children: React.ReactNode }): JSX.Element | null {
  const { user, loading, bootstrap } = useAuth();

  // Trigger the /me fetch the first time a protected route mounts. Public
  // routes (playground, viewer, login, register) never call this, so
  // unauthenticated visitors don't hit the auth endpoint at all.
  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
